import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBilling } from "@/context/BillingContext";
import Paywall from "@/components/Paywall";

/**
 * Wraps any authenticated route. If `requirePaid` or `requirePro` is set,
 * the page is replaced with a Paywall card when entitlement is missing.
 *
 *   <ProtectedRoute requirePaid>           // any paid feature
 *   <ProtectedRoute requirePro featureName="Voter List">  // Pro-only
 */
export default function ProtectedRoute({ children, requirePaid, requirePro, featureName }) {
  const { user } = useAuth();
  const billing = useBilling();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;

  // Wait for billing to load before deciding to paywall (prevents flash).
  if ((requirePaid || requirePro) && !billing.loaded) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500" data-testid="billing-loading">
        Loading…
      </div>
    );
  }
  if (requirePro && !billing.can_voter_list) {
    return <Paywall reason={billing.can_paid ? "pro_required" : "trial_ended"} featureName={featureName || "this feature"} />;
  }
  if (requirePaid && !billing.can_paid) {
    return <Paywall reason="trial_ended" featureName={featureName || "this feature"} />;
  }
  return children;
}
